import api from './api';

const withStore = (storeId, config = {}) => ({ ...config, _storeId: storeId });

const saveBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const RevenueService = {
  getReport: async (storeId, params) => {
    const response = await api.get('/revenue', withStore(storeId, {
      params,
      paramsSerializer: { indexes: null },
    }));
    return response.data;
  },

  downloadPdf: async (storeId, params) => {
    const response = await api.get('/revenue/pdf', withStore(storeId, { params, responseType: 'blob' }));
    saveBlob(response.data, `revenue-${params.from}-${params.to}.pdf`);
  },

  downloadCsv: async (storeId, params) => {
    const response = await api.get('/revenue/csv', withStore(storeId, { params, responseType: 'blob' }));
    saveBlob(response.data, `revenue-${params.from}-${params.to}.csv`);
  },
};

export default RevenueService;
